export const experimentInfoPrefixStyle = {
    color: 'green',
    fontWeight: 'bold',
    marginRight: '0.5rem',
    fontFamily: 'monospace',
};

